const BottomNavigation = {
  Home: 'Home',
  organization: 'Apiaries',
  notes: 'Notes',
  IoT: 'IoT',
  errorNoIoT: 'You have no connected IoT-devices!'
}

export default BottomNavigation
